// removed by extract-text-webpack-plugin
module.exports = {"dotControls":"arrowStyles__dotControls__3c3da005","dotWrapper":"arrowStyles__dotWrapper__3c3da005","dot":"arrowStyles__dot__3c3da005","current":"arrowStyles__current__3c3da005","buyer":"arrowStyles__buyer__3c3da005","trade":"arrowStyles__trade__3c3da005","dotCarouselWrapper":"arrowStyles__dotCarouselWrapper__3c3da005","clear":"arrowStyles__clear__3c3da005"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/global/components/carousel/views/arrowStyles.scss
// module id = 332
// module chunks = 4 5 6 7 8 21 23 25 35